import React, { useState, useEffect, useRef } from "react";
import './checkride.css';
import {
    Grid,
    Button
} from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import PageHeader from "../../../Components/PageHeader";
import LeftControl from "../../../Components/LeftControl";
import { helpers } from "../../../helpers";

/** Local deoendencies & Libraries */
import Services from '../../../Services';
import DynamicInput from "../../../Components/InputComponents/DynamicInput";
import DynamicFormFields from "../../../Components/InputComponents/DynamicFormFields";
import { checkRideKeyNames, list_checkride_type } from "../../../Components/TableComponents/constants";
import GoBack from "../../../Components/GoBackButton/GoBack";
import GoClose from "../../../Components/GoBackButton/Close";
import PageLayout from "../../../Components/LayoutComponents/PageLayout";
import { message } from "antd";
const {
    employee,
    Storage
} = Services;

const {
    showSnackBar,
} = helpers;

var moment = require('moment-timezone')

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const EnterCheckRide = () => {
    let history = useHistory();
    const storage = new Storage();

    //loader states
    const [loading, setLoading] = useState(false);
    const [radioQuestions, setRadioQuestions] = useState([])
    const [crideTextFields, setCrideTextFields] = useState({
        assisting: [],
        locomotiveConsist: '',
        TCLoads: '',
        TCEmpties: '',
        TCTotalTonage: '',
        TMTraveled: '',
        Comments: '',
        type: ''
    })
    const [crideAutoComplete, setAutoComplete] = useState({
        EngineerId: '',
    })
    const [crideDates, setCrideDates] = useState({
        date: '',
        time: '',
        endDate: '',
        endTime: '',

    })
    const [crideRadios, setCrideRadios] = useState([])
    const [lists, setLists] = useState({
        currentUser: '',
        users: [],
        positions: [],
        departments: [],
        sites: [],
        crews: [],
        assistants: []

    })


    const resetData = () => {

    }


    const apiBody = async () => {
        let {
            EngineerId
        } = crideAutoComplete;

        let {
            locomotiveConsist,
            TCLoads,
            TCEmpties,
            TCTotalTonage,
            TMTraveled,
            Comments,
            type
        } = crideTextFields

        // locomotiveConsist = parseInt(locomotiveConsist, 10); // 10 is the radix/base for the conversion

        let {
            date,
            time,
            endDate,
            endTime
        } = crideDates;

        if ([date, time, endTime, endDate]?.includes("")) {
            message.error("Kindly fill all time fields")
            return { data: null, flag: false }
        }

        let sum = 0
        crideRadios?.forEach(({ score, answer }) => answer === "NO" ? sum = (+sum) + (+score) : () => { })
        return {
            data: {
                EngineerId,
                locomotiveConsist,
                TCLoads,
                TCEmpties,
                TCTotalTonage,
                TMTraveled,
                Comments,
                type: type?.label,
                date: moment(new Date(date)).format('YYYY-MM-DD').toString(),
                time,
                endDate: moment(new Date(endDate)).format('YYYY-MM-DD').toString(),
                endTime,
                Question: crideRadios,
                totalScore: 100 - sum
            },
            flag: true
        }

    }

    const submitBtn = async (event,) => {
        event.preventDefault();

        try {
            let data = await apiBody()
            if (!data?.flag) return
            let result = await employee.checkride_table_submit(data?.data)
            if (result?.httpStatus == 200) {

                setLoading(false);
                resetData()
                setCrideRadios([])
                setTimeout(() => {
                    history.push({
                        pathname: "/safety-testing",
                        state: { activeTab: 1 }
                    });
                }, 1500);

                return showSnackBar('Form Successfully Submitted');
            }

        } catch (error) {
            setLoading(false);

            return showSnackBar(`Error Occured while submitting form: ${error}`);
        }
        return false;
    };



    const setListData = async () => {
        let userList = await employee.checkride_table();
        if (userList?.httpStatus == 200) {
            userList = userList?.data;
            userList.map(row => {
                row.name = `${row.firstName} ${row.lastName}`
            })
        }

        let assistingCrewList = await employee.get_crew_user_listing();

        if (assistingCrewList?.httpStatus == 200) {
            assistingCrewList = assistingCrewList?.data?.rows;
            assistingCrewList.map(row => {
                row.name = `${row?.firstName} ${row?.lastName}`
            })
        }


        let siteList = await employee.get_site_listing()
        if (siteList?.httpStatus == 200) {
            siteList = siteList?.data;
        }


        let currentUser = JSON.parse(storage.get('user_profile'))

        setLists({ ...lists, users: userList, currentUser: currentUser, assistants: assistingCrewList, assistants: assistingCrewList })
        return true
    }

    const fetchCheckRideFields = async () => {
        let response = await employee.get_employee_check_ride_fields()
        setRadioQuestions(response?.data?.map((ques, i) => {
            return {
                id: ques?.id,
                type: 4,
                name: ques?.name,
                isRequired: true,
                keyName: checkRideKeyNames[i],
                score: ques?.score,
                points: ques?.points,
                index: i
            }
        }))
    }
    useEffect(() => {
        //listing function
        setListData()
        fetchCheckRideFields()

    }, []);

    const stateMap = {
        1: crideTextFields,
        2: crideDates,
        3: crideAutoComplete,
        5: crideDates,
        12: crideTextFields,
    }

    const handleOnChange = (value, key, type) => {
        // if (key === "endTime") {
        //     if ([crideDates?.date, crideDates?.endDate]?.includes("")) return
        //     if (moment(crideDates?.date)?.isSame(crideDates?.endDate) && crideDates?.time >= value) {
        //         message.error("End time should be greater than start time")
        //         setCrideDates({ ...crideDates, [key]: null })
        //         return
        //     }
        // }
        // else {
        const set = {
            1: setCrideTextFields({ ...crideTextFields, [key]: value }),
            2: setCrideDates({ ...crideDates, [key]: value }),
            3: setAutoComplete({ ...crideAutoComplete, [key]: value.id }),
            5: setCrideDates({ ...crideDates, [key]: value }),
            12: setCrideTextFields({ ...crideTextFields, [key]: value }),
        }
        return set[type];
    }

    const currentUser = JSON.parse(storage.get('user_profile'))

    const disableDatesBeforeStartDate = ({ date }) => {
        if (!crideDates?.date) {
            return false;
        }
        return date <= crideDates?.endDate;
    };
    let fields = [
        { type: 1, name: "Evaluators ID", initial: `${currentUser?.firstName} ${currentUser?.lastName}`, isDisabled: true, keyName: '', className: 'mbolder' },
        { type: 3, key: 'name', options: lists.assistants, name: "Engineer Id", isRequired: true, keyName: 'EngineerId' },
        { type: 3, key: 'label', options: list_checkride_type, name: "Checkride Type", isRequired: true, keyName: 'type' },
        { type: 1, fieldType: 'text', name: "Lead Locomotive", isRequired: true, keyName: 'locomotiveConsist' },
        { type: 1, fieldType: 'number', name: "Train Consist-Load", isRequired: true, keyName: 'TCLoads' },
        { type: 1, fieldType: 'number', name: "Train Consist -Empties", isRequired: true, keyName: 'TCEmpties' },
        { type: 1, fieldType: 'number', name: "Train Consist -Total Tonnage ", isRequired: true, keyName: 'TCTotalTonage' },
        { type: 1, fieldType: 'number', name: "Total Miles Traveled", isRequired: true, keyName: 'TMTraveled' },
        { type: 6, name: "Comment", isRequired: true, keyName: 'Comments' },
        { type: 7 },
        { type: 11, name: "Start date", keyName: 'date', isRequired: true, initial: crideDates?.date, },
        { type: 11, name: "End date", keyName: 'endDate', isRequired: true, initial: crideDates?.endDate, disabledDate: disableDatesBeforeStartDate, minDate: crideDates?.date },
        { type: 5, name: "Start time", keyName: 'time', isRequired: true, initial: crideDates?.time },
        { type: 5, name: "End time", keyName: 'endTime', isRequired: true, initial: crideDates?.endTime },
        { type: 7 },
        { type: 7 },
        { type: 7 },
        { type: 7 },
    ]


    return (
        <PageLayout>
            <Grid className="PagesFrame">
                <PageHeader />
                <Grid id="PageTitle">Enter Check Ride</Grid>
                {/* <GoBack path={"/safety-testing"} /> */}
                <GoBack path={"/safety-testing"} state={{ activeKey: 2 }} />

                <form onSubmit={submitBtn} >
                    <div style={{ display: "grid", gridTemplateColumns: "50% 50%", gap: "20px" }}>
                        <DynamicFormFields state={stateMap} fields={fields?.slice(0, 14)} onChange={handleOnChange} grid={4} />
                    </div>
                    <div style={{ display: "grid", gridTemplateColumns: "50% 50%", gap: "20px", marginTop: "50px" }}>
                        <DynamicFormFields fields={radioQuestions} state={crideRadios} setState={setCrideRadios} grid={4} />
                    </div>
                    <Grid xs={12} container justify="flex-end" className="mt50">
                        {/* <Link to="/safety-testing" state={{ activeTab: 1 }} className="LinkButtonBack mr10">Close</Link> */}
                        <GoClose path={"/safety-testing"} state={{ activeTab: 1 }} />
                        <Button
                            type="submit"
                            className="LinkButton"

                        >
                            Submit
                        </Button>
                    </Grid>
                </form>

            </Grid>
        </PageLayout>
    );
}

export default EnterCheckRide;
